module.exports = __webpack_public_path__ + "static/media/overview_1.1ea093e3.png";